(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('NasracAdminCustomerAccountDeleteController',NasracAdminCustomerAccountDeleteController);

    NasracAdminCustomerAccountDeleteController.$inject = ['$uibModalInstance', 'entity', 'NasracAdminCustomerAccount'];

    function NasracAdminCustomerAccountDeleteController($uibModalInstance, entity, NasracAdminCustomerAccount) {
        var vm = this;

        vm.nasracAdminCustomerAccount = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            NasracAdminCustomerAccount.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
